// extracted by mini-css-extract-plugin
export var active = "_gj-7";
export var blink = "_gj-8";
export var dropDownSelector = "_gj-4";
export var dropDownWrapper = "_gj-3";
export var fakeCursor = "_gj-6";
export var fontSizeButton = "_gj-9";
export var formQuillEditor = "_gj-0";
export var pressed = "_gj-a";
export var qlBlank = "_gj-1";
export var textFormattingToolbar = "_gj-2";
export var textToolbarOption = "_gj-5";